import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Altoona",
    route: "#",
    tagline: "Polk County expedited passport services",
    highlights: ["Altoona area coverage", "Serving Des Moines metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Ames",
    route: "#",
    tagline: "Story County expedited passport processing",
    highlights: ["Iowa State University area", "Serving Story County"],
    badge: null,
    status: "coming",
  },
  {
    name: "Ankeny",
    route: "#",
    tagline: "Polk County expedited passport services",
    highlights: ["Ankeny area coverage", "Serving Des Moines metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Bettendorf",
    route: "#",
    tagline: "Scott County expedited passport services",
    highlights: ["Quad Cities area coverage", "Serving Davenport, Moline"],
    badge: null,
    status: "coming",
  },
  {
    name: "Boone",
    route: "#",
    tagline: "Boone County expedited passport services",
    highlights: ["Boone area coverage", "Serving Des Moines corridor"],
    badge: null,
    status: "coming",
  },
  {
    name: "Burlington",
    route: "#",
    tagline: "Des Moines County expedited passport services",
    highlights: ["Burlington area coverage", "Serving Southeast Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Cedar Rapids",
    route: "/cities/cedar-rapids",
    tagline: "Linn County's expedited passport hub",
    highlights: ["Linn County coverage", "Serving Marion, Hiawatha"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Clinton",
    route: "#",
    tagline: "Clinton County expedited passport services",
    highlights: ["Clinton area coverage", "Serving Mississippi River communities"],
    badge: null,
    status: "coming",
  },
  {
    name: "Coralville",
    route: "#",
    tagline: "Johnson County expedited passport services",
    highlights: ["Iowa River Landing area", "Serving Iowa City metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Council Bluffs",
    route: "#",
    tagline: "Pottawattamie County expedited passport services",
    highlights: ["Omaha metro area coverage", "Serving Southwest Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Davenport",
    route: "/cities/davenport",
    tagline: "Quad Cities expedited passport processing",
    highlights: ["Quad Cities coverage", "Serving Bettendorf, Rock Island"],
    badge: null,
    status: "live",
  },
  {
    name: "Decorah",
    route: "#",
    tagline: "Winneshiek County expedited passport services",
    highlights: ["Decorah area coverage", "Serving Northeast Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Des Moines",
    route: "/cities/des-moines",
    tagline: "Iowa's capital expedited passport hub",
    highlights: ["Polk County coverage", "Serving West Des Moines, Ankeny"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Dubuque",
    route: "#",
    tagline: "Dubuque County expedited passport services",
    highlights: ["Historic riverfront area", "Serving Tri-State region"],
    badge: null,
    status: "coming",
  },
  {
    name: "Fort Dodge",
    route: "#",
    tagline: "Webster County expedited passport services",
    highlights: ["Fort Dodge area coverage", "Serving North Central Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Grinnell",
    route: "#",
    tagline: "Poweshiek County expedited passport services",
    highlights: ["Grinnell College area", "Serving Central Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Indianola",
    route: "#",
    tagline: "Warren County expedited passport services",
    highlights: ["Indianola area coverage", "Serving Des Moines metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Iowa City",
    route: "/cities/iowa-city",
    tagline: "Johnson County university expedited passport hub",
    highlights: ["University of Iowa area", "Serving Coralville, North Liberty"],
    badge: null,
    status: "live",
  },
  {
    name: "Johnston",
    route: "#",
    tagline: "Polk County expedited passport services",
    highlights: ["Johnston area coverage", "Serving Des Moines metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Keokuk",
    route: "#",
    tagline: "Lee County expedited passport services",
    highlights: ["Keokuk area coverage", "Serving Southeast Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Marion",
    route: "#",
    tagline: "Linn County expedited passport services",
    highlights: ["Marion area coverage", "Serving Cedar Rapids metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Marshalltown",
    route: "#",
    tagline: "Marshall County expedited passport services",
    highlights: ["Marshalltown area coverage", "Serving Central Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Mason City",
    route: "#",
    tagline: "Cerro Gordo County expedited passport services",
    highlights: ["Mason City area coverage", "Serving North Central Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Muscatine",
    route: "#",
    tagline: "Muscatine County expedited passport services",
    highlights: ["Muscatine area coverage", "Serving Mississippi River communities"],
    badge: null,
    status: "coming",
  },
  {
    name: "Newton",
    route: "#",
    tagline: "Jasper County expedited passport services",
    highlights: ["Newton area coverage", "Serving Des Moines corridor"],
    badge: null,
    status: "coming",
  },
  {
    name: "North Liberty",
    route: "#",
    tagline: "Johnson County expedited passport services",
    highlights: ["North Liberty area", "Serving Iowa City metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Oskaloosa",
    route: "#",
    tagline: "Mahaska County expedited passport services",
    highlights: ["Oskaloosa area coverage", "Serving Central Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Ottumwa",
    route: "#",
    tagline: "Wapello County expedited passport services",
    highlights: ["Ottumwa area coverage", "Serving Southeast Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Pella",
    route: "#",
    tagline: "Marion County expedited passport services",
    highlights: ["Pella area coverage", "Serving Central Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Sioux City",
    route: "#",
    tagline: "Woodbury County western Iowa passport hub",
    highlights: ["Woodbury County coverage", "Serving Tri-State area"],
    badge: null,
    status: "coming",
  },
  {
    name: "Spencer",
    route: "#",
    tagline: "Clay County expedited passport services",
    highlights: ["Spencer area coverage", "Serving Northwest Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "Urbandale",
    route: "#",
    tagline: "Polk County expedited passport services",
    highlights: ["Urbandale area coverage", "Serving Des Moines metro"],
    badge: null,
    status: "coming",
  },
  {
    name: "Waverly",
    route: "#",
    tagline: "Bremer County expedited passport services",
    highlights: ["Waverly area coverage", "Serving Wartburg College community"],
    badge: null,
    status: "coming",
  },
  {
    name: "Waterloo",
    route: "#",
    tagline: "Black Hawk County expedited passport services",
    highlights: ["Waterloo-Cedar Falls area", "Serving Northeast Iowa"],
    badge: null,
    status: "coming",
  },
  {
    name: "West Des Moines",
    route: "#",
    tagline: "Polk County expedited passport services",
    highlights: ["West Des Moines area", "Serving Des Moines metro"],
    badge: null,
    status: "coming",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function IowaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Iowa Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Iowa Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Iowa</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Iowa locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}